var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5954 1.72917C6.58012 3.03785 7.51511 4.29457 8.31582 5.35286C8.27603 5.39066 12.1552 1.50239 12.1354 1.57798C11.7226 1.07719 11.3496 0.61891 10.8423 0H15V3.98275C14.3485 3.48196 13.876 3.11817 13.13 2.54651C11.7027 4.13866 9.55419 5.95287 8.03731 7.64897C6.67959 6.04736 6.27675 5.51349 5.39647 4.33237C3.9542 5.82531 2.53182 7.25683 1.08955 8.74978C1.15918 8.86316 -0.0244803 7.44109 0.00038647 7.41274C1.58688 5.73554 3.7105 3.63314 5.5954 1.72917Z",
    fill: "#5DD39E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrowUpIcon.1c9a40d12d51609658ffaab7488d97c9.svg";
export { ForwardRef as ReactComponent };